const scrollTop = () => {
	// On crée le bouton de scroll top
	//@ts-ignore
	const scrollTopText = js_trad.ScrollTop

	document.querySelector('body').insertAdjacentHTML('beforeend', `<button data-scrollTop class="button-scroll" type="button">
	<span class="sr-only">${scrollTopText}</span></button>`);
}
// On toggle une class au scroll pour show/hide le btn
const handleScroll = () => {
	const btn = document.querySelector('[data-scrollTop]') as HTMLButtonElement;
	const windowHeight = window.innerHeight;
	let y = window.scrollY;
	y > windowHeight ? btn.classList.add('button-scroll--show') : btn.classList.remove('button-scroll--show');
}

const clickScroll = () => {
	const btn = document.querySelector('[data-scrollTop]') as HTMLButtonElement;
	btn.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	})
}

scrollTop();

window.addEventListener('DOMContentLoaded', () => {
	handleScroll();
	clickScroll();
})
window.addEventListener('scroll', () => {
	handleScroll();
})